if($('.empty-cart-hover').length == 0) {
  $('<div class="empty-cart-hover popup-widget"><h2>'+emptycarttitle+'</h2><p>'+emptycartetext1+'<a href="'+linktocontact+'">'+emptycartcontact+'</a>. '+emptycarttext2+'</p></div>').appendTo(".user-action-in");
}

function mhemptycart(){
  $(".cart-widget-product:contains('Váš nákupný košík je prázdný'), .cart-heading:contains('Váš nákupný košík je prázdný'), .cart-widget-product:contains('Your shopping cart is empty'), .cart-widget-product:contains('Your shopping cart is empty')").closest("body").removeClass("cart-window-visible");
  $(".cart-count:not(.full), .empty-cart-hover").hover(function(){
    $("body").addClass("empty-cart-hover-visible user-action-visible");
      }, function(){
    $("body").removeClass("empty-cart-hover-visible user-action-visible");
  });
}

$(document).ready(function() {
  mhemptycart();
  });
  document.addEventListener('ShoptetDOMContentLoaded', function () {
    mhemptycart(); 
  });

if($('.in-kosik, .in-cart').length){
  function mhpridatslevu(){
    $('.show-related').text(doplnky_text)
    $('.cart-table-header .p-name').text('Produkt')
    $('.cart-table tr').each(function(){
      var findcenazakus = $(this).find('.p-price.p-cell').html();
      var findptotal = $(this).find('.p-total');
      $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
    })
  };
  mhpridatslevu()

  document.addEventListener('ShoptetDOMCartContentLoaded', function () {
    mhpridatslevu();
  });
}         

  function exist(e){if($(e).length)return!0};

  
    
  $(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
      $(".advanced-order .h1:not(.advanced-order-suggestion)").text(addtocart),
      $(".advanced-order .btn.btn-conversion").text(tocart),
      exist(".advanced-order .h1.advanced-order-suggestion")&&$(".advanced-order .h1.advanced-order-suggestion").text(castonakupuji),
      $(".advanced-order .extras-wrap").prepend('<div class="extra step-back"><span class="btn inline-block btn-back" href="#" id="mhclose">'+backtoshop+'</span></div>'),
      
      $('body').on("click","#mhclose",function(){
          $("div#colorbox button#cboxClose").click();
      })
      $.colorbox.resize()
  })

  if($('.in-dekujeme').length){
    $('.cart-table tr').each(function(){
      var findcenazakus = $(this).find('.p-quantity').html();
      var findptotal = $(this).find('.p-price');
      $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
    })
  }
  exist(".in-kosik, .in-cart")&&(
    $(document).on("ready ShoptetDOMCartContentLoaded",function(){
      if($(".cart-empty").length){
      $("body").addClass("prazdny-kosik"), 
      $('.cart-empty .cart-row').append('<div class="cartisempty"><p>'+popisprazdnykosik+'</p><div class="text-center"><a href="/" class="btn btn-secondary">'+backtoshoplink+'</a></div>')
  
    }
    })
  )

  
  
  if($('.in-kosik, .in-cart').length){
    function mhslider(){
      $('.in-kosik .hodit, .in-cart .hodit').slick({
        slidesToShow: 3,
       slidesToScroll: 1,
       autoplay: false,
       autoplaySpeed: 3000,
       dots: true,
       arrow: true,
       responsive: [
      {
           breakpoint: 1199,
           settings: {
             slidesToShow: 3,
             slidesToScroll: 1,
           }
         },
         {
           breakpoint: 991,
           settings: {
             slidesToShow: 2,
             slidesToScroll: 1,
           }
         },
         {
           breakpoint: 767,
           settings: {
             slidesToShow: 1,
             slidesToScroll: 1,
           }
         }
       ]
      });
      };
    function mhimage(){
      $('.hodit .product').each(function(){
        $(this).find('.image img').attr('src', $(this).find('.image img').attr('data-src'))
      })
    }
    function mhsouvisejici(){
      $('.in-kosik .cart-total, .in-cart .cart-total').before('<div class="hoditse"><div class="left"><h2 class="vyhodny-nakup">'+vyhodnynakup+'</h2><p>'+vyhodnynakuptext+'</p></div><div class="right"><div id="products" class="products products-page products-block hodit"></div></div></div>')
     
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: vyhodneurl,
            success: function(e) {
              var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#products").html();
              null !== t && ($(".hodit").html(t),mhimage(), mhslider())
            
            }
          });
            
     
    }
    
  
    mhsouvisejici()
  document.addEventListener('ShoptetDOMCartContentLoaded', function () {
      mhsouvisejici();
    })
  }

$("#billCity").closest(".form-group").addClass("form-group-city")
$("#billZip").closest(".form-group").addClass("form-group-zip")

if($('.in-dakujeme').length){
  $('.content-inner').after('<div class="thank-you-bottom"></div><div class="link-bottom"></div>')
  $('.thank-you-bottom').append($('.co-payment-method'))
  $('.thank-you-bottom').append($('.co-order'))
  $('.link-bottom').append($('.order-complete-links'))
}

$(document).ready(function() {
mhfreeship();
});
document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
mhfreeship(); 
});

document.addEventListener('ShoptetCartUpdated', function () {
mhfreeship(); 
});

function mhfreeship(){
findprice = dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft
console.log(findprice)
if(findprice<0){
  $('.cart-widget').addClass('free-ship')
}
if(findprice>0){
  $('.cart-widget').removeClass('free-ship')
  
}
}